import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-confirmation-box',
  templateUrl: './confirmation-box.component.html',
  styleUrls: ['./confirmation-box.component.css']
})
export class ConfirmationBoxComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() okButtonText: string;
  @Input() cancelButtonText: string;
  @Input() showCancel: boolean = true;;
  @Input() subject: Subject<boolean>;

  action(value: boolean) {
    this.activeModel.close(value);
    if (this.subject != undefined) {
      this.subject.next(value);
      this.subject.complete();
    }
  }
  constructor(private activeModel: NgbActiveModal) { }

  ngOnInit(): void {
  }
  accept() {
    this.activeModel.close(true);
  }
  decline() {
    this.activeModel.close(false);
  }
}
